module.exports = __webpack_public_path__ + "static/media/greivinVasquez.3d43f6d6.jpg";